import React, { useState, useEffect, Fragment } from 'react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Card, CardHeader, CardContent, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import CargomaticModal from 'components/v2/modal';
import AddButton from 'components/v2/buttons/AddButton';
import ClipboardCopyIcon from 'components/v2/icons/ClipboardCopyIcon';
import SessionStore from 'stores/SessionStore';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const CHARS_DISPLAYED = 4;
const maskKey = (key) => {
    return '*'
        .repeat(key.length - CHARS_DISPLAYED)
        .concat(key.slice(key.length - CHARS_DISPLAYED));
};
const APIKeys = (props) => {
    const [keys, setKeys] = useState([]);
    const [showModal, setModalVisibility] = useState(false);
    const [generatedKey, setGeneratedKey] = useState('');
    const { user, cardClassName } = props;
    const { t } = useTranslation();
    useEffect(() => {
        const getKeys = async () => {
            try {
                const result = await UserWebAPIUtils.getAPIKeys(user._id, (e) => {
                    throw e;
                });
                if (result && result.success) {
                    setKeys(result.data.items.map((item) => {
                        return Object.assign(Object.assign({}, item), { maskedValue: maskKey(item.value) });
                    }));
                }
            }
            catch (e) {
                console.log(e);
            }
        };
        getKeys();
    }, []);
    const generateKey = async () => {
        const result = await UserWebAPIUtils.generateAPIKey(user._id).catch((e) => {
            console.log(e);
        });
        if (result && result.success) {
            setGeneratedKey(result.data.key);
            setModalVisibility(true);
            setKeys((currentKeys) => {
                return [
                    ...currentKeys,
                    Object.assign(Object.assign({}, result.data), { maskedValue: maskKey(result.data.value) }),
                ];
            });
        }
    };
    const renderKeyList = () => {
        return keys.map((data) => {
            return (React.createElement(Fragment, { key: data._id },
                React.createElement("div", { className: "flex" },
                    React.createElement("div", { className: "w-full flex" },
                        React.createElement("span", { className: "w-40" }, data.maskedValue),
                        React.createElement(CopyToClipboard, { text: data.value },
                            React.createElement("span", { className: "cursor-pointer" },
                                React.createElement(ClipboardCopyIcon, null))))),
                React.createElement("span", null, data.createdBy),
                React.createElement("span", null, moment(data.dateCreated).format('L'))));
        });
    };
    const resetGeneratedKey = () => {
        setGeneratedKey('');
        setModalVisibility(false);
    };
    const renderGeneratedKey = () => {
        return (React.createElement(CargomaticModal, { title: t('GENERATED_KEY'), style: { top: '30%' }, show: showModal, onHide: resetGeneratedKey, body: React.createElement("div", { className: "font-medium" }, generatedKey), footer: () => { } }));
    };
    const authorizedForAPIUse = () => {
        if (user._type === 'Shipper') {
            return user.can_pay || user.can_pay_manually;
        }
        if (user._type === 'Carrier') {
            return user.authorized;
        }
        return false;
    };
    const toolTipMessages = {
        shipper: 'Only users with a registered method of payment can generate api keys',
        carrier: 'Only authorized users can generate api keys',
    };
    return (React.createElement(Card, { className: cardClassName },
        React.createElement(CardHeader, null,
            React.createElement("header", { className: "flex items-center justify-between" },
                React.createElement("h3", { className: "my-0" }, t('API_KEYS')),
                authorizedForAPIUse() ? (React.createElement(AddButton, { onClick: generateKey })) : (React.createElement(TooltipProvider, null,
                    React.createElement(Tooltip, null,
                        React.createElement(TooltipTrigger, null,
                            React.createElement(AddButton, { disabled: true })),
                        React.createElement(TooltipContent, { side: "right" }, SessionStore.isShipper()
                            ? toolTipMessages.shipper
                            : toolTipMessages.carrier)))))),
        React.createElement(CardContent, null,
            React.createElement("div", { className: "grid grid-cols-3 gap-4" },
                React.createElement("span", { className: "font-medium" }, titleize(t('KEY'))),
                React.createElement("span", { className: "font-medium" }, t('CREATED_BY')),
                React.createElement("span", { className: "font-medium" }, t('DATE_CREATED')),
                renderKeyList()),
            generatedKey && renderGeneratedKey())));
};
export default APIKeys;
